import { ProductGroup } from '../../../types/ProductGroup';

import { RequisitionGroupSelection } from './types/RequisitionGroupSelection';

export const REQUISITION_GROUP_SECTIONS: ProductGroup[][] = [
    [
        ProductGroup.CYLINDER_OIL,
        ProductGroup.SYSTEM_OIL_2_STROKE,
        ProductGroup.ENGINE_OIL_4_STROKE,
        ProductGroup.ANCILLARY_OIL,
        ProductGroup.GREASE,
    ],
    [ProductGroup.TEST_KIT, ProductGroup.SAMPLE_ANALYSIS],
    [ProductGroup.BASE_OIL, ProductGroup.BLEND_ON_BOARD_ADDITIVES],
];
export const REQUISITION_SELECTABLE_GROUPS = REQUISITION_GROUP_SECTIONS.flat();
const REQUISITION_MAIN_GROUPS = [
    ProductGroup.CYLINDER_OIL,
    ProductGroup.ENGINE_OIL_4_STROKE,
    ProductGroup.SYSTEM_OIL_2_STROKE,
    ProductGroup.BASE_OIL,
    ProductGroup.BLEND_ON_BOARD_ADDITIVES,
];
const REQUISITION_MINOR_GROUPS = [ProductGroup.ANCILLARY_OIL, ProductGroup.GREASE];

export const REQUISITION_GROUP_PRESETS: Record<RequisitionGroupSelection, ProductGroup[]> = {
    [RequisitionGroupSelection.ALL]: REQUISITION_SELECTABLE_GROUPS,
    [RequisitionGroupSelection.MAIN]: REQUISITION_MAIN_GROUPS,
    [RequisitionGroupSelection.MINOR]: REQUISITION_MINOR_GROUPS,
    [RequisitionGroupSelection.CUSTOM]: REQUISITION_SELECTABLE_GROUPS,
};
